import { Button, DrawerFooter } from '@growtherapy/sprout-ui';

export function ClientInformationSchedulingDrawerFooter({
  onClickEditAppointment,
}: {
  onClickEditAppointment: () => void;
}) {
  return (
    <DrawerFooter>
      <Button use='secondary' onClick={onClickEditAppointment}>
        Edit appointment
      </Button>
    </DrawerFooter>
  );
}
